import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {impactSummary} from "../apiConfigs"

export const ImpactSummaryApi = createAsyncThunk(
    'auth/analytics/ImpactSummaryApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(impactSummary, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const ImpactSummarySlice = createSlice({
    name: 'analytics/ImpactSummaryApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(ImpactSummaryApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(ImpactSummaryApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(ImpactSummaryApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const ImpactSummaryReducer = ImpactSummarySlice.reducer